/**
 * TEMP SOLUTION
 * Ranks a floor by its absolute level so floors read top-to-bottom of the
 * building: above-ground ascending (Ground → Roof), then basements
 * (B1 → B2). Basements are pushed past every above-ground floor by
 * offsetting them beyond any realistic level (+1000), then ordered by depth.
 *
 * Used for both the floor-chip ordering and the camera-list sort.
 */
export function floorRank(level: number): number {
  return level >= 0 ? level : 1000 + Math.abs(level);
}
